import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useSelector } from "react-redux";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";

const CustomConfirmDialog = ({
  handleConfirm,
  isLoading,
  title,
  text,
  handleClose,
}) => {
  const { confirmDialogOpen } = useSelector((state) => state.dialogSlice);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={confirmDialogOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 3,
            p: { xs: 1, sm: 2 },
            minWidth: { xs: "90vw", sm: 400 },
            maxWidth: "95vw",
            m: 0,
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: 2,
        }}
      >
        <WarningAmberRoundedIcon
          sx={{
            fontSize: 56,
            color: theme.palette.warning.main,
            mb: 1,
          }}
        />
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            textAlign: "center",
            fontWeight: 700,
            fontSize: { xs: "1.2rem", sm: "1.5rem" },
            pb: 0,
          }}
        >
          {title}
        </DialogTitle>
      </Box>
      <DialogContent
        sx={{
          pb: 1,
          pt: 0,
        }}
      >
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            textAlign: "center",
            fontSize: { xs: "1rem", sm: "1.1rem" },
            color: "text.secondary",
            mb: 1,
          }}
        >
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 2,
          pb: { xs: 1, sm: 2 },
          pt: 0,
        }}
      >
        <Button
          onClick={handleClose}
          color="inherit"
          variant="outlined"
          size="large"
          disabled={isLoading}
          sx={{ minWidth: 100 }}
        >
          Hayır
        </Button>
        <Button
          onClick={handleConfirm}
          autoFocus
          color="warning"
          variant="contained"
          size="large"
          disabled={isLoading}
          sx={{ minWidth: 100 }}
          startIcon={
            isLoading && <CircularProgress size={20} color="inherit" />
          }
        >
          {isLoading ? "İşleniyor..." : "Evet"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default CustomConfirmDialog;
